import React, { useState } from "react";

//UI Material
import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";

//Material Icons
import { Add, Cancel, Person } from "@mui/icons-material";

//Local components
import Form from "../basics/Form";

export default function ActionOfColaboratorDrawer({
  open,
  setOpen,
  data = {},
}) {
  // ==========>Component States<==========
  //State for productData
  const [actionData, setActionData] = useState({});
  //State for setting loader
  const [isLoading, setIsLoading] = useState(false);

  const actionOfColaboratorForm = [
    {
      selection: "textfield",
      id: "reason",
      initialValue: data.client,
      xs: 12,
      md: 12,
      label: "Motivo",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Motivo",
      content: [],
      style: {},
    },
     {
      selection: "textfield",
      id: "justification",
      initialValue: data.client,
      xs: 12,
      md: 12,
      label: "Justificación",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Justificación",
      content: [],
      style: {},
    },
  ];

  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Person color="secondary" />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            {`Acción Personal`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold">
            {`Colaborador: ${data.user}`}
          </Typography>
        </Grid>
          <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold">
            {`Posición: ${data.position}`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Form
            data={actionOfColaboratorForm}
            handleStateChange={setActionData}
          />
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ color: "white" }}
              endIcon={<Cancel />}
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancelar
            </Button>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                //onClick={setItem}
              >
                {"Guardar registro"}
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
    </SwipeableDrawer>
  );
}
